import { sleep } from "./utils";
import { debounce } from "lodash";

declare const jQuery: any;
const $ = jQuery;

const onSmallScreen: Function = window["iw"].breakpoints.onSmallScreen;
const registerScrollDetectEvent: Function = window["iw"].registerScrollDetectEvent;

export function initCatsAndExpertsColumns(): void
{
    const $wraps = $(".hs-cats-and-experts-columns");
    if ($wraps.length === 0)
    {
        return;
    }
    const $window = $(window);
    $wraps.each(function () {
        const $wrap = $(this);
        const $colWraps = $wrap.find("[data-columns]");
        const getColWrap = (id: string) => $colWraps.filter(`[data-columns="${id}"]`);
        const $switches = $wrap.find("[data-switch]");

        // Init switches

        $switches.on("click", async function (e) {
            const $switch = $(this);
            if ($switch.is(".selected"))
            {
                return;
            }
            $switches.not($switch).removeClass("selected");
            $switch.addClass("selected");
            const id: string = $switch.attr("data-switch");
            const $colWrap = getColWrap(id);
            $colWraps.not($colWrap).removeClass("show");
            const $cols = $colWrap.find(".column")
            if (onSmallScreen())
            {
                $cols.css({ "transition-duration": "", "opacity": "" });
                $colWrap.addClass("show");
                $.scrollTo($wrap, 400, { axis: "y" });
                return;
            }
            $cols.css({ "transition-duration": "0" });
            await sleep(20);
            $cols.css({ opacity: 0 });
            await sleep(10);
            $cols.css({ "transition-duration": "" });
            await sleep(10);
            $colWrap.addClass("show");
            $cols.each(function (index: number) {
                const $col = $(this);
                setTimeout(() => {
                    $col.css({ opacity: 1 });
                }, index * 200);
            });
        });

        // Rise up on load

        function getThreshold(): number
		{
			const viewportHeight = $window.outerHeight();
			const divTop = $wrap.offset().top;
			return (divTop - viewportHeight) + 200;
        }
        
        function onPassForward(): void
		{
			$wrap.removeClass("hidden");
		}

		function onPassBackward(): void
		{
			$wrap.addClass("hidden");
        }
        
        onPassBackward();

        const forceTrigger = registerScrollDetectEvent(onPassForward, onPassBackward, getThreshold);

		$window.on("scroll", debounce(forceTrigger, 300));
    });
}
